import { MenuRoute } from '@blb-ventures/react-components';
import {
  DrawerProps,
  IconButton,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  TypographyProps,
} from '@mui/material';
import { StyledList } from '@web/common/components/more-button';
import { SmartMenu } from '@web/common/components/navigation/smart-menu';
import { SafeAreaDrawer } from '@web/common/components/safe-area-drawer';
import { FC, ReactNode } from 'react';

interface SortDrawerProps extends DrawerProps {
  title?: string;
  titleProps?: TypographyProps;
  menuItems: MenuRoute[];
  anchor: DrawerProps['anchor'];
  open?: boolean;
  onCloseIcon?: ReactNode;
  onClose: () => void;
}

export const SortDrawer: FC<SortDrawerProps> = ({
  title,
  titleProps,
  menuItems,
  anchor = 'bottom',
  open,
  onCloseIcon,
  onClose,
  ...props
}) => {
  return (
    <SafeAreaDrawer open={open} anchor={anchor} onClose={onClose} {...props}>
      <StyledList anchor={anchor}>
        {title && (
          <ListItem>
            <ListItemText
              primary={title}
              primaryTypographyProps={{ variant: 'h5', ...titleProps }}
            />
            {onCloseIcon && (
              <ListItemSecondaryAction>
                <IconButton onClick={onClose}>{onCloseIcon}</IconButton>
              </ListItemSecondaryAction>
            )}
          </ListItem>
        )}
        <SmartMenu hasDivider menuItems={menuItems} itemsOnly />
      </StyledList>
    </SafeAreaDrawer>
  );
};
